import React from 'react'
import { Link } from 'react-router-dom';
import './tophead.css';   


const Tophead = () => {
  return (
    <> 
  
        <div className="rs-toolbar">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="rs-toolbar-left">
            <div className="welcome-message">
              <i className="glyph-icon flaticon-phone-call" />
              <span>
                <a href="tel:1234567890">+1234-567-890</a>
              </span>
            </div>
            <div className="welcome-message">
              <i className="glyph-icon flaticon-email" />
              <span>
                <a href="mailto:info@domain.com">info@domain.com</a>
              </span>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="rs-toolbar-right">
            <div className="toolbar-share-icon">
              <ul>
                <li>
                  <a href="#">
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-google-plus" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
  
  
  )
}

export default Tophead
